export const LAYER_WIDTH = 100
export const LAYER_HEIGHT = 100
export const LAYER_DEPTH = 35



// WEBPACK FOOTER //
// ./three/constants/dimens.js